import { mapFields } from "vuex-map-fields";
export const RBF0400A40 = {
  //출금계좌목록
  //자주쓰는계좌목록
  //최근이체내역
  created() {},
  beforeDestroy() {
    // this.drwotAccountList = [];
  },
  computed: {
    ...mapFields("transfer", ["RBF0400A40", "RBF0405G40", "RBF0405T40", "RBF0408W40", "drwotAcno"]),
    ...mapFields(["siteCode", "sessionInfo"]),
  },
  methods: {
    /**
     * 출금계좌목록
     */
    RBF0400A40CallDrwot() {
      if (this.sessionInfo.isLogin) {
        if (_.isNil(this.RBF0400A40.drwot)) {
          const _this = this;
          return new Promise(resolve => {
            this.$post(
              "/customer/acn/DrwotAcnRegiInq",
              { inquryUserStupAcnDstcd1: "1", brncoOtrbnkRmtancMdiaDstcd: "98", authChkYn: _this.authChkYn, pageLineCnt: 1000, dmndPageNo: "1", chnlDtalsBzwkDstcd: "43" },
              response => {
                _this.$set(this.RBF0400A40, "drwot", response.outItem.rmtancAplcnListGrid);
                resolve(this.makeListDrwot(response.outItem.rmtancAplcnListGrid, this.cncycd, this.page));
              },
              response => {
                this.$log.info("fail >>> " + response);
                resolve(response);
              },
            );
          });
        } else {
          return this.makeListDrwot(null, this.cncycd, this.page);
        }
      } else {
        return [];
      }
    },
    /**
     * 출금계좌목록에서 통화코드별 filter
     * @param {Array} list 출금계좌목록
     * @param {String} cncycd 통화코드 : 예금신규, 이자/월부금납부에서 특정 통화코드로 filter가 필요
     * @param {String} page 호출되는 화면 (DrwotAcno.vue - props로 선언)
     *                      예금신규 - depositNew
     *                      이자/월부금납부 - interestLoanPay
     *                      당행이체 + 외화이체 - transfer
     *                      타행이체 - otrbnk
     *                      자동이체등록 - autoTransfer
     *                      해외송금신청 - ovses
     * @return {Array} 이체화면별 filter 적용된 배열
     */
    makeListDrwot(list, cncycd, page) {
      let tmp = [];
      if (!list && this.RBF0400A40.drwot === undefined) return [];
      for (const key of list || this.RBF0400A40.drwot) {
        // let als = "";
        // if (key.acnAls !== undefined || key.acnAls !== "") {
        //   als = " : " + key.acnAls;
        // }
        let tempObj = {
          value: `${this.$removeAcn(key.acno)};${key.cncycd};${key.acnAls}`,
          text: `${key.acno} (${key.cncycd})`,
          data: {
            serno: key.serno, //출금계좌일련번호
            dpostBal: key.dpostBal, //잔액
            cncycd: key.cncycd, //통화코드
            acno: key.acno, //계좌번호
            alias: key.acnAls, //계좌별칭
            dailyRmainClam: key.dailyRmainClam, //일일잔여한도금액
            rpsntDrwotAcnYn: key.rpsntDrwotAcnYn, // 베트남 메인출금계좌 설정 여부
          },
        };

        let isAdd = false;
        if (page == "depositNew" || page == "interestLoanPay" || page == "depositTermi") {
          //예금신규, 이자/월부금납부
          if (cncycd) {
            if (key.cncycd == cncycd) isAdd = true;
          } else {
            isAdd = true;
          }
        } else if (page == "transfer") {
          //당행이체 + 외화이체
          switch (this.siteCode) {
            case this.$config.SITECODE_OGMMR: //미얀마
              //당행이체 : MMK -> MMK
              //외화이체 : USD -> MMK/USD, MMK -> MMK --> 1차 운영 중 제외됨
              if (key.cncycd == this.$config.CNCYCD_MMK) isAdd = true;
              // else if (key.cncycd == this.$config.CNCYCD_USD) isAdd = true;
              if (this.pageOption == "mmQr") {
                this.$set(tempObj.data, "dailyRmainClam", key.mmqrDailyRmainClam);
              }
              break;

            case this.$config.SITECODE_OGCBD: //캄보디아
              //당행이체 : USD -> USD
              //외화이체 : KHR -> KHR, KHR -> USD
              if (key.cncycd == this.$config.CNCYCD_USD) isAdd = true;
              else if (key.cncycd == this.$config.CNCYCD_KHR) isAdd = true;
              break;

            case this.$config.SITECODE_OGHCM: //베트남
              //당행이체 : VND -> VND
              //외화이체 : USD -> USD/VND
              if (key.cncycd == this.$config.CNCYCD_USD) isAdd = true;
              else if (key.cncycd == this.$config.CNCYCD_VND) isAdd = true;
              break;
            case this.$config.SITECODE_OGIND: //인도
              //당행이체 : INR -> INR
              if (key.cncycd == this.$config.CNCYCD_INR) isAdd = true;
              break;
            case this.$config.SITECODE_OGAUC: //오클랜드
              //당행이체 : NZD -> NZD
              //외화이체 : NZD -> USD/AUD/EUR/JPY
              //          USD -> USD/NZD
              //          AUD -> AUD/NZD
              //          EUR -> EUR/NZD
              //          JPY -> JPY/NZD
              if (key.cncycd == this.$config.CNCYCD_NZD) isAdd = true;
              else if (key.cncycd == this.$config.CNCYCD_USD) isAdd = true;
              else if (key.cncycd == this.$config.CNCYCD_AUD) isAdd = true;
              else if (key.cncycd == this.$config.CNCYCD_EUR) isAdd = true;
              else if (key.cncycd == this.$config.CNCYCD_JPY) isAdd = true;
              break;
          }
        } else if (page == "otrbnk" || this.page == "cbmnet") {
          //타행이체
          switch (this.siteCode) {
            case this.$config.SITECODE_OGMMR: //미얀마는 기준통화코드와 동일한 계좌만 추가
              if (key.cncycd == this.sessionInfo.userInfo.baseCncycd) isAdd = true;
              break;
            case this.$config.SITECODE_OGHCM:
              if (this.pageOption == "CITAD") {
                //VND -> VND
                //USD -> USD
                if (key.cncycd == this.sessionInfo.userInfo.baseCncycd) isAdd = true;
                else if (key.cncycd == this.$config.CNCYCD_USD) isAdd = true;
              } else if (this.pageOption == "NAPAS") {
                //기준통화코드와 동일한 계좌만 추가
                if (key.cncycd == this.sessionInfo.userInfo.baseCncycd) isAdd = true;
              }
              break;
            default:
              isAdd = true;
          }
        } else if (page == "qrPayment"|| page=="otrPayment") {
          //QR결제
          if (this.siteCode == this.$config.SITECODE_OGHCM) {
            //VND 계좌만 추가
            if (key.cncycd == this.$config.CNCYCD_VND) isAdd = true;
          }
        } else if (page == "otrbnkQt") {
          //타행대량이체
          if (this.siteCode == this.$config.SITECODE_OGHCM) {
            //기준통화코드와 동일한 계좌만 추가
            if (key.cncycd == this.sessionInfo.userInfo.baseCncycd) isAdd = true;
          } else {
            isAdd = true;
          }
        } else if (this.page == "fcTrsaccRsultInq") {
          //외화이체내역조회
          switch (this.siteCode) {
            case this.$config.SITECODE_OGMMR: //미얀마는 USD -> MMK/USD, MMK -> MMK
              if (key.cncycd == this.$config.CNCYCD_USD) isAdd = true;
              if (key.cncycd == this.$config.CNCYCD_MMK) isAdd = true;
              break;

            case this.$config.SITECODE_OGCBD: //캄보디아는 KHR -> KHR, KHR -> USD, USD -> USD
              if (key.cncycd == this.$config.CNCYCD_KHR) isAdd = true;
              if (key.cncycd == this.$config.CNCYCD_USD) isAdd = true;
              break;

            case this.$config.SITECODE_OGHCM: //베트남은 USD ->
              if (key.cncycd == this.$config.CNCYCD_USD) isAdd = true;
              break;

            default:
              isAdd = true;
          }
        } else if (page == "autoTransfer") {
          //자동이체등록
          switch (this.siteCode) {
            case this.$config.SITECODE_OGMMR:
            case this.$config.SITECODE_OGAUC: //기준통화코드와 동일한 계좌만 추가
              if (key.cncycd == this.sessionInfo.userInfo.baseCncycd) isAdd = true;
              break;
            case this.$config.SITECODE_OGCBD: //캄보디아는 KHR -> KHR, USD -> USD
              if (key.cncycd == this.$config.CNCYCD_USD) isAdd = true;
              else if (key.cncycd == this.$config.CNCYCD_KHR) isAdd = true;
              break;
            case this.$config.SITECODE_OGHCM: //베트남은 VND -> VND
              if (key.cncycd == this.$config.CNCYCD_VND) isAdd = true;
              break;
          }
        } else if (page == "ovses") {
          //해외송금신청
          switch (this.siteCode) {
            case this.$config.SITECODE_OGHCM: //베트남은 USD,vnd로 송금
              if (key.cncycd == this.$config.CNCYCD_USD) isAdd = true;
              if (key.cncycd == this.$config.CNCYCD_VND) isAdd = true;
              break;
            case this.$config.SITECODE_OGMMR: //미얀마는 USD로만 송금
            case this.$config.SITECODE_OGCBD: //캄보디아는 USD로만 송금
              if (key.cncycd == this.$config.CNCYCD_USD) isAdd = true;
              break;
            default:
              isAdd = true;
          }
        } else {
          isAdd = true;
        }

        if (isAdd) {
          tmp.push(tempObj);
        }
      }
      return tmp;
    },
    /**
     * 자주쓰는계좌목록(구 입금계좌)
     */
    RBF0400A40CallMnrcv() {
      if (this.sessionInfo.isLogin) {
        if (_.isNil(this.RBF0400A40.mnrcv)) {
          const _this = this;
          return new Promise(resolve => {
            this.$post(
              "/customer/acn/MnrcyAcnRegiInq",
              {
                inquryUserStupAcnDstcd1: "2",
                brncoOtrbnkRmtancMdiaDstcd:
                  this.pageOption == "NAPAS"
                    ? "98"
                    : this.pageOption == "CBMNET"
                    ? "07"
                    : this.pageOption == "CITAD"
                    ? this.siteCode == this.$config.SITECODE_OGMMR
                      ? "07"
                      : "00"
                    : "98", //(98:전체, 00:CITAD, 03:NAPAS, 05: BAKONG)
                pageLineCnt: 1000,
                dmndPageNo: "1",
                chnlDtalsBzwkDstcd: "43", //비대면채널구분코드(40:인터넷뱅킹 / 43:스타뱅킹)
              },
              response => {
                _this.$set(this.RBF0400A40, "mnrcv", response.outItem.rmtancAplcnListGrid);
                if (response.outItem.totalLineCnt > 0) {
                  resolve(_this.makeListMnrcv(response.outItem.rmtancAplcnListGrid));
                } else {
                  resolve([]);
                }
              },
              response => {
                this.$log.info("fail >>> " + response);
                resolve(response);
              },
            );
          });
        } else {
          return this.makeListMnrcv();
        }
      } else {
        return [];
      }
    },
    /**
     * 입금계좌정보 selectbox optionList 형식으로 변환
     * (중요) store/transfer - drwotAcno에 있는 출금계좌 정보(`${계좌번호};${통화코드};${별명}`) 사용
     *  - 선택된 출금계좌번호를 제외 됨
     * (중요) this.obaobDstcd : 당행/타행 구분 (1:당행, 2:타행), 호출하는 화면에서 props 또는 data로 선언되어 있어야 함
     * @param {Array} list 입금계좌 API 결과목록. null이면 RBF0400A40거래 결과로 filter
     * @param {Strimg} type 화면 구분값
     *                      RBF0400A40: 입금계좌(기본값)
     *                      RBF0404F40: 전계좌조회
     *                      RBF0405G40: 즉시이체결과조회
     *                      RBF0405T40: 타행이체신청내역조회
     * @return {Array} 이체화면별 filter 적용된 배열
     */
    makeListMnrcv(list, type = "RBF0400A40") {
      let tmp = [];
      // const tmpList = list || this.RBF0400A40.mnrcv;
      // const info = this.drwotAcno
      const cncycdFilter = this.drwotAcno.cncycd;
      const acnoDup = this.drwotAcno.acno;
      for (const key of list || this.RBF0400A40.mnrcv) {
        //출금계좌번호로 선택된 데이터는 pass
        if (type != "RBF0405G40" && key.acno == acnoDup) continue;
        let alias = _.isNil(key.acnAls) ? (_.isNil(key.acnoAls) ? "" : key.acnoAls) : key.acnAls;
        let isAdd = false;
        let cncycd = "";

        switch (type) {
          case "RBF0400A40": //입금계좌(기본값)]
            cncycd = key.cncycd;
            break;
          case "RBF0404F40": //전계좌조회
            cncycd = key.cncycd;
            break;
          case "RBF0405G40": //즉시이체결과조회
            cncycd = key.lnkgAcnCncycd;
            break;
          case "RBF0405T40": //타행이체신청내역조회
            cncycd = key.mnrcvCncycd;
            break;

          default:
            cncycd = key.cncycd;
            break;
        }

        //(1:당행,2:타행)
        if (type == "RBF0404F40" || type == "RBF0405T40" || key.obaobDstcd == this.obaobDstcd || this.obaobDstcd == "0") {
          if (this.onlyBaseCncycd) {
            //기준통화코드와 동일한 계좌만 추가
            if (this.sessionInfo.userInfo.baseCncycd == cncycd) isAdd = true;
          } else {
            switch (this.siteCode) {
              case this.$config.SITECODE_OGMMR:
                if (this.page == "otrbnk" || this.page == "cbmnet") {
                  if (cncycd == this.$config.CNCYCD_MMK) isAdd = true;
                } else if (this.page == "transfer") {
                  //계좌간이체+외화이체
                  // if (cncycdFilter == this.$config.CNCYCD_USD) {
                  //   //USD -> 가능통화 = USD, MMK : 외화이체 --> 1차 운영에서 제외됨
                  //   if (cncycd == this.$config.CNCYCD_MMK || cncycd == this.$config.CNCYCD_USD) isAdd = true;
                  // } else
                  if (cncycdFilter == this.$config.CNCYCD_MMK) {
                    //MMK -> 가능통화 = USD : 외화이체 --> 1차 운영에서 제외됨
                    //MMK -> 가능통화 = MMK : 계좌간이체
                    if (cncycd == this.$config.CNCYCD_MMK) isAdd = true;
                  } else {
                    isAdd = true;
                  }
                } else {
                  isAdd = true;
                }
                break;
              case this.$config.SITECODE_OGCBD:
                //캄보디아
                if (this.page == "transfer") {
                  //계좌간이체+외화이체
                  if (cncycdFilter == this.$config.CNCYCD_KHR) {
                    //KHR -> 가능통화 = KHR, USD : 외화이체
                    if (cncycd == this.$config.CNCYCD_KHR || cncycd == this.$config.CNCYCD_USD) isAdd = true;
                  } else if (cncycdFilter == this.$config.CNCYCD_USD) {
                    //USD -> 가능통화 = KHR : 외화이체
                    //USD -> 가능통화 = USD : 계좌간이체
                    isAdd = true;
                  } else {
                    isAdd = true;
                  }
                } else if (this.page == "autoTransfer") {
                  if (cncycdFilter == this.$config.CNCYCD_KHR) {
                    //KHR -> 가능통화 = KHR
                    if (cncycd == this.$config.CNCYCD_KHR) isAdd = true;
                  } else if (cncycdFilter == this.$config.CNCYCD_USD) {
                    //USD -> 가능통화 = USD
                    if (cncycd == this.$config.CNCYCD_USD) isAdd = true;
                  } else {
                    isAdd = true;
                  }
                } else {
                  isAdd = true;
                }
                break;
              case this.$config.SITECODE_OGHCM:
                //베트남
                if (this.page == "otrbnk") {
                  //VND -> VND, USD -> USD 가능
                  if (cncycdFilter == this.$config.CNCYCD_USD) {
                    if (cncycd == this.$config.CNCYCD_USD) isAdd = true;
                  } else if (cncycdFilter == this.$config.CNCYCD_VND) {
                    if (cncycd == this.$config.CNCYCD_VND) isAdd = true;
                  }
                } else if (this.page == "transfer") {
                  //계좌간이체+외화이체
                  //VND -> VND, USD -> USD/VND만 가능
                  if (cncycdFilter == this.$config.CNCYCD_USD) {
                    if (cncycd == this.$config.CNCYCD_USD) isAdd = true;
                    if (cncycd == this.$config.CNCYCD_VND) isAdd = true;
                  } else if (cncycdFilter == this.$config.CNCYCD_VND) {
                    if (cncycd == this.$config.CNCYCD_VND) isAdd = true;
                  }
                } else {
                  isAdd = true;
                }
                break;
              case this.$config.SITECODE_OGIND:
                //인도
                if (this.page == "otrbnk") {
                  //기준통화코드와 동일한 계좌만 추가
                  if (this.sessionInfo.userInfo.baseCncycd == cncycd) isAdd = true;
                } else {
                  isAdd = true;
                }
                break;
              case this.$config.SITECODE_OGAUC:
                //오클랜드
                if (this.page == "otrbnk") {
                  //기준통화코드와 동일한 계좌만 추가
                  if (this.sessionInfo.userInfo.baseCncycd == cncycd) isAdd = true;
                } else if (this.page == "transfer") {
                  //계좌간이체+외화이체
                  if (cncycdFilter == this.$config.CNCYCD_NZD) {
                    //NZD -> 가능통화 = USD, AUD, EUR, JPY : 외화이체
                    //NZD -> 가능통화 = NZD : 계좌간이체
                    if (
                      cncycd == this.$config.CNCYCD_USD ||
                      cncycd == this.$config.CNCYCD_AUD ||
                      cncycd == this.$config.CNCYCD_EUR ||
                      cncycd == this.$config.CNCYCD_JPY ||
                      cncycd == this.$config.CNCYCD_NZD
                    ) {
                      isAdd = true;
                    }
                  } else if (cncycdFilter == this.$config.CNCYCD_USD) {
                    //USD-> 가능통화 = USD, NZD : 외화이체
                    if (cncycd == this.$config.CNCYCD_USD || cncycd == this.$config.CNCYCD_NZD) {
                      isAdd = true;
                    }
                  } else if (cncycdFilter == this.$config.CNCYCD_AUD) {
                    //AUD -> 가능통화 = AUD, NZD : 외화이체
                    if (cncycd == this.$config.CNCYCD_AUD || cncycd == this.$config.CNCYCD_NZD) {
                      isAdd = true;
                    }
                  } else if (cncycdFilter == this.$config.CNCYCD_EUR) {
                    //EUR -> 가능통화 = EUR, NZD : 외화이체
                    if (cncycd == this.$config.CNCYCD_EUR || cncycd == this.$config.CNCYCD_NZD) {
                      isAdd = true;
                    }
                  } else if (cncycdFilter == this.$config.CNCYCD_JPY) {
                    //JPY -> 가능통화 = JPY, NZD : 외화이체
                    if (cncycd == this.$config.CNCYCD_JPY || cncycd == this.$config.CNCYCD_NZD) {
                      isAdd = true;
                    }
                  } else {
                    isAdd = true;
                  }
                } else {
                  isAdd = true;
                }
                break;
              case this.$config.SITECODE_OGLD:
                //런던
                if (this.page == "fcTransfer") {
                  if (cncycdFilter == this.$config.CNCYCD_GBP) {
                    //GBP -> 가능통화 = USD, EUR
                    if (cncycd == this.$config.CNCYCD_USD || cncycd == this.$config.CNCYCD_EUR) {
                      isAdd = true;
                    }
                  } else if (cncycdFilter == this.$config.CNCYCD_EUR) {
                    //EUR -> 가능통화 = GBP, EUR
                    if (cncycd == this.$config.CNCYCD_GBP || cncycd == this.$config.CNCYCD_EUR) {
                      isAdd = true;
                    }
                  } else if (cncycdFilter == this.$config.CNCYCD_USD) {
                    //USD -> 가능통화 = USD, GBP
                    if (cncycd == this.$config.CNCYCD_USD || cncycd == this.$config.CNCYCD_GBP) {
                      isAdd = true;
                    }
                  }
                } else {
                  isAdd = true;
                }
                break;
              default:
                isAdd = true;
                break;
            }
          }

          if (isAdd) {
            switch (type) {
              case "RBF0400A40":
                //입금계좌(기본값)
                tmp.push({
                  value: `${key.acno};${key.cncycd};${alias}`,
                  text: `${key.acno} (${key.cncycd})`, //계좌구분 null => 입금계좌주명
                  data: {
                    serno: key.serno, //입금일련번호
                    othrBnkName: key.othrBnkName, //입금타은행명
                    draweFname: key.dpstrName, //입금계좌예금주명
                    rcevnBnkIfscCode: key.rcevnBnkIfscCode, //입금은행IFSC코드
                    brnName: key.brnName, //부점명
                    mnrcvBrnNo: key.mnrcvBrnNo, //입금부점번호
                    acno: key.acno, //계좌번호
                    cncycd: key.cncycd, //통화코드
                    alias: alias, //별칭
                    obaobDstcd: this.obaobDstcd, //당/타행구분
                    draweAcitmDstcd: key.draweAcitmDstcd, //수취인계정구분코드(01:계좌, 02:카드, 03:폰)
                    brncoOtrbnkRmtancMdiaDstcd: key.brncoOtrbnkRmtancMdiaDstcd, //00:해당무, 01:RTGS, 02:NEFT, 03:NAPAS, 04:RFT, 05:BAKONG, 06:BNZ, 99:기타, "":신청
                  },
                });
                break;

              case "RBF0404F40":
                //전계좌조회
                tmp.push({
                  value: `${key.acno};${key.cncycd};${alias}`,
                  text: `${key.acno} (${key.cncycd})`, //계좌구분 null => 입금계좌주명
                  data: {
                    acno: key.acno, //계좌번호
                    cncycd: key.cncycd, //통화코드
                    alias: alias, //별칭
                    obaobDstcd: "1", //당/타행구분
                  },
                });
                break;
              case "RBF0405G40":
                //즉시이체결과조회
                tmp.push({
                  value: `${key.cupldAcno};${key.lnkgAcnCncycd};${alias}`,
                  text: `${key.cupldAcno} (${key.lnkgAcnCncycd})`, //계좌구분 null => 입금계좌주명
                  data: {
                    acno: key.acno, //계좌번호
                    cncycd: key.cncycd, //통화코드
                    draweFname: key.draweFname, //수취인명
                    sysLastPrcssYMS: key.sysLastPrcssYMS, //이체일시
                    mrvamt: key.mrvamt, //금액
                    obaobDstcd: this.obaobDstcd, //당/타행구분
                    cupldAcno: key.cupldAcno, //입금계좌번호
                    cupldCncycd: key.lnkgAcnCncycd, //입금계좌통화코드
                    drwotAmt: key.drwotzAmt, //출금금액
                  },
                });
                break;
              case "RBF0405T40":
                //타행이체신청내역조회
                tmp.push({
                  value: `${key.mnrcvAcno};${key.mnrcvCncycd};${alias}`,
                  text: `${key.mnrcvAcno} (${key.mnrcvCncycd})`, //계좌구분 null => 입금계좌주명
                  data: {
                    // serno: key.serno, //입금일련번호
                    othrBnkName: key.mnrcvOthrBnkName, //입금타은행명
                    rcevnBnkIfscCode: key.rcevnBnkIfscCode, //입금은행IFSC코드
                    brnName: key.mnrcvBrnName, //부점명
                    mnrcvBrnNo: key.mnrcvBrnNo, //입금부점번호
                    acno: key.drwotAcno, //계좌번호
                    cncycd: key.mnrcvCncycd, //통화코드
                    alias: key.mnrcvAcnAls, //별칭
                    draweFname: key.mnrcvDpstrName, //수취인명
                    sysLastPrcssYMS: key.drblYms, //이체일시
                    mrvamt: key.mnrcvTrsaccAmt, //금액
                    obaobDstcd: this.$config.OBAOB_DSTCD_2, //당/타행구분
                    cupldAcno: key.mnrcvAcno, //입금계좌번호
                    cupldCncycd: key.mnrcvCncycd, //입금계좌통화코드
                    drwotAmt: key.mnrcvTrsaccAmt, //출금금액
                    draweAcitmDstcd: key.draweAcitmDstcd, //수취인계정구분코드(01:계좌, 02:카드, 03:폰)
                    brncoOtrbnkRmtancMdiaDstcd: key.rmtancPtrnDstcd, //00:해당무, 01:RTGS, 02:NEFT, 03:NAPAS, 04:RFT, 05:BAKONG, 06:BNZ, 99:기타, "":신청
                  },
                });
                break;
            }
          }
        }
      }
      return tmp;
    },
    //출금가능금액
    balanceView() {
      if (this.selected.value === undefined || this._.isEqual(this.selected.value, "")) {
        alert(this.$t("M001-027"));
      } else {
        this.$post(
          "/account/inqury/AcnInqDtlPop",
          {
            acno: this.selected.value.split(";")[0],
            acnDsticCd: "1",
            brncoEcrypPwdValdnYn: "0",
          },
          this.RBF0404B40Suc,
        );
      }
    },
    //계좌번호 선택
    onChange(id, obj) {
      this.selected = obj;
      //   this.balanceShow = false;
      this.$emit("onChange", obj);
    },
    //
    RBF0404B40Suc(res) {
      //   this.balanceShow = true;
      this.selectedBalance = {
        dailyTrsaccAcamtRmainLimt: res.outItem.dailyTrsaccAcamtRmainLimt, //당일이체잔여한도
        drwotAbilAmt: res.outItem.drwotAbilAmt, //출금가능금액
        cncycd: res.outItem.cncycd, //통화코드
      };
    },
    //값초기화
    // init() {
    //   this.selected = {};
    //   //   this.balanceShow = false;
    //   this.$refs.selectBox.selected = "";
    // },
    // setValue(value) {
    //   this.$refs.selectBox.selected = value;
    // },
  },
};

/**
 * RBF0408A40_FX환산금액산출
 */
export const RBF0408A40 = {
  computed: {
    ...mapFields(["sessionInfo"]),
  },
  methods: {
    /**
     *
     * @param {String} fxTranz 통화코드 기준 옵션(01:상대통화코드, 02:통화코드)
     * @param {String} cncycd 통화코드
     * @param {String} fxCncycd 상대통화코드
     * @param {String || Number} tranAmt 상대통화금액
     */
    RBF0408A40Call(fxTranz, cncycd, fxCncycd, tranAmt) {
      let param = {
        ovsesAplyExrtDstcd: _.isEqual(this.sessionInfo.userInfo.baseCncycd, fxTranz == "01" ? fxCncycd : cncycd) ? "01" : "02",
        cncycd: cncycd, //통화코드
        fxCncycd: fxCncycd, //상대통화코드
        tranAmt: String(tranAmt), //상대통화금액
      };

      this.$post("/transfer/mntacc/FcTrsaccAucInq", param, this.RBF0408A40Suc);
    },
  },
};

/**
 * RBF0405G40 - 즉시이체결과조회(당행)
 * (중요) store/transfer - drwotAcno에 있는 출금계좌 정보(`${계좌번호};${통화코드};${별명}`) 사용
 */
export const RBF0405G40 = {
  methods: {
    async RBF0405G40Call() {
      if (_.isNil(this.RBF0405G40)) {
        return await new Promise(resolve => {
          this.$post(
            "/transfer/mntacc/ImdtTrsaccRsultInq",
            {
              dmndPageNo: 1, //요청페이지번호
              pageLineCnt: 10, //페이지라인수
              acno: this.drwotAcno.acno, //계좌번호
              sortGubun: "1", //조회결과순서(1:최근순)
              obaobDstcd: this.obaobDstcd, //당타행구분코드 (1:당행, 2:타행)
            },
            response => {
              this.RBF0405G40 = response.outItem;
              resolve(response.outItem);
            },
          );
        });
      } else {
        return this.RBF0405G40;
      }
    },
  },
};

/**
 * RBF0405T40 - 타행이체신청내역조회
 */
export const RBF0405T40 = {
  methods: {
    async RBF0405T40Call() {
      if (_.isNil(this.RBF0405T40)) {
        return await new Promise(resolve => {
          this.$post(
            "/transfer/otrbnk/OtrbnkTrsaccAplcnHistInq",
            {
              acno: this.drwotAcno.acno, //계좌번호
              obaobDstcd: "2", //날짜없이 전문호출 가능 코드
              dmndPageNo: 1,
              pageLineCnt: 10,
              rmtancPtrnDstcd: this.pageOption == "NAPAS" ? "98" : this.pageOption == "CBMNET" ? "07" : this.pageOption == "CITAD" ? "00" : "98", //(98:전체, 00:CITAD, 03:NAPAS, 05: BAKONG, 07 : CBMNET2),
              resultSeq: "01", //조회결과순서
              tranStartYmd: "",
              tranEndYmd: "",
              rmtancFnshYn: "1", //1: 송금완료
              chnlDtalsBzwkDstcd: "43", //비대면채널구분코드(40:인터넷뱅킹 / 43:스타뱅킹)
            },
            response => {
              let removeCnt = 0; //제거된 건수

              if (this.siteCode == this.$config.SITECODE_OGMMR) {
                //미얀마 일 때 임시로 10월 20일 오후2시 이후 데이터만 조회되도록 수정
                removeCnt = _.remove(response.outItem.dataGrid, value => {
                  return value.drblYms < "20221027140000000000";
                }).length;
              }
              this.RBF0405T40 = response.outItem.totalLineCnt - removeCnt > 0 ? response.outItem.dataGrid : [];
              resolve(response.outItem.totalLineCnt > 0 ? response.outItem.dataGrid : []);
            },
          );
        });
      } else {
        return this.RBF0405T40;
      }
    },
  },
};

/**
 * RBF0404J40 - 계좌예금주명 조회
 */
export const RBF0404J40 = {
  computed: {
    ...mapFields(["operGroupCd"]),
  },
  methods: {
    RBF0404J40Call(acno) {
      return new Promise(resolve => {
        this.$post(
          "/account/inqury/AccountHolderInq",
          {
            operGroupCd: this.operGroupCd, //운영그룹코드
            obaobDstcdc: "1", //당타행구분코드 1:당행, 2:타행
            acno: acno, //계좌번호
          },
          response => {
            resolve(response.outItem);
          },
        );
      });
    },
  },
};

/**
 * RBF0408W40 - 현지은행목록조회
 */
export const RBF0408W40 = {
  methods: {
    async RBF0408W40Call(tranDstCd) {
      if (_.isNil(this.RBF0408W40)) {
        return await new Promise(resolve => {
          this.$post(
            "/customer/acn/LocalBnkListInquiry",
            {
              dmndPageNo: 1,
              pageLineCnt: 1000,
              tranDstCd: tranDstCd,
            },
            response => {
              this.RBF0408W40 = response.outItem;
              resolve(response.outItem);
            },
          );
        });
      } else {
        return this.RBF0408W40;
      }
    },
  },
};

/**
 * 소수점 허용 국가 및 통화코드 체크
 */
export const mnrcvTrsaccCheck = {
  computed: {
    ...mapFields(["siteCode", "sessionInfo"]),
  },
  methods: {
    getAmtPointCheck(fxTranz, mnrcvCncycd, drwotCncycd) {
      let cncycd = fxTranz == "01" ? mnrcvCncycd : drwotCncycd;

      if (cncycd == "ITL" || cncycd == "ESP" || cncycd == "JPY" || cncycd == "KRW" || cncycd == "VND") {
        return false;
      } else {
        return true;
      }
    },
    getMinTrsaccAmt(fxTranz, mnrcvCncycd, drwotCncycd, page) {
      let amt;

      //통화에 따른 최소 금액 설정
      if (!this.getAmtPointCheck(fxTranz, mnrcvCncycd, drwotCncycd)) {
        //소수점 입력 불가 통화
        amt = 1;
      } else {
        amt = 0.01;
      }

      if (page == "transfer") {
        //당행이체
        if (this.siteCode == this.$config.SITECODE_OGAUC) {
          if (this.sessionInfo.userInfo.baseCncycd == drwotCncycd && drwotCncycd == mnrcvCncycd) {
            amt = 0.01;
          } else {
            amt = 0.1;
          }
        }
      } else if (page == "otrbnk") {
        //타행이체
        if (this.siteCode == this.$config.SITECODE_OGAUC) {
          if (this.sessionInfo.userInfo.baseCncycd == drwotCncycd && drwotCncycd == mnrcvCncycd) {
            amt = 0.01;
          } else {
            if (drwotCncycd == "NZD" || mnrcvCncycd == "NZD") amt = 0.1;
            else amt = 0.01;
          }
        }
      } else if (page == "ovses") {
        //외화이체
        if (this.siteCode == this.$config.SITECODE_OGAUC) {
          if (drwotCncycd == "NZD" || mnrcvCncycd == "NZD") amt = 0.1;
          else amt = 0.01;
        }
      }

      return amt;
    },
  },
};
